
import React, { useEffect, useState } from 'react';
import { getLstExamSvc } from './questionPaperSvc';
import "./questionPaper.css";

const ExamHeader = (props) => {
    const [examId, setExamId] = useState(props.examId);
    const [lstExam, setLstExam] = useState([]);
    const [dynamicWidth, setDynamicWidth] = useState('calc(100% / ' + 9 + ')');

    useEffect(() => {
        setExamId(props.examId);
        getLstExamSvc(cbLstExamResponse);
    }, []);

    function cbLstExamResponse(data) {
        if (data.SvcStatus === 'Success') {
            setLstExam(data.lstExam);
            setDynamicWidth('calc(100% / ' + data.lstExam.length + ')');
            props.changeExam(data.lstExam[0]);
        }
    }

    return (
        <div className="col-sm-12 col-centered padding-remove" >
            <div className="col-sm-9 padding-remove" >
                <div className="wrapper-box-pattern">
                    {lstExam.map((obj) => {
                        const isSelected = obj.examId === props.examId;
                        return (
                            <div
                                className={isSelected ? 'selected exam-block-pattern' : 'exam-block-pattern'}
                                onClick={() => props.changeExam(obj)}
                                key={obj.examId}
                                style={{
                                    border: isSelected ? '2px solid #007bff' : '1px solid #ccc',
                                }}
                            >
                                <div className="exam-name">{obj.exam}</div>
                                <div className="exam-dates">{obj.fromDt} - {obj.toDt}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="col-sm-3 " >
                <button type="button" style={{ marginTop: 25 }}
                    className="btn btn-primary pull-right"
                    onClick={(e) => { e.stopPropagation(); props.generateExamPattern(); }}
                >
                    Generate Question Paper
                </button>
            </div>
        </div>
    );
};

export default ExamHeader;
